<script lang="ts">
	import { _ } from 'svelte-i18n';
	import Card from '@smui/card';
	import TableLoading from '../../../../../../../shared/components/common/Loading/TableLoading.svelte';
	import Checkbox from '@smui/checkbox';
	import Pagination from '../../../../../../../shared/components/common/Table/Pagination.svelte';

    export let dataList;
    export let filters;

    $: [data, loading, error] = dataList;
</script>
<Card class="md:px-8 md:py-8" padded>
	<div class="flex flex-col">
		<div class="sm:-mx-6 lg:-mx-8 -my-2 overflow-x-auto">
			<div class="sm:px-6 lg:px-8 inline-block min-w-full py-2 align-middle">
				<div class="overflow-hidden">
					<table class="min-w-full p-0 m-0 text-sm leading-10 border-t-4 border-collapse border-black table-auto">
						<thead>
							<tr class="p-1">
								<th scope="col" class="border-b p-2.5 text-center text-xs leading-6 tracking-wider"
									>{$_('page.employee.list.province')}</th
								>
								<th scope="col" class="border-b p-2.5 text-center text-xs leading-6 tracking-wider"
									>{$_('page.employee.list.city')}</th
								>
								<th scope="col" class="border-b p-2.5 text-center text-xs leading-6 tracking-wider"
									>{$_('page.employee.list.postal_code')}</th
								>
								<th scope="col" class="border-b p-2.5 text-center text-xs leading-6 tracking-wider"
									>{$_('page.employee.list.address')}</th
								>
								<th scope="col" class="border-b p-2.5 text-center text-xs leading-6 tracking-wider"
									>{$_('page.employee.list.location')}</th
								>
								<th scope="col" class="border-b p-2.5 text-center text-xs leading-6 tracking-wider"
									>{$_('page.employee.list.status')}</th
								>
							</tr>
						</thead>
						<tbody>
							{#if $loading}
								<tr>
									<td colspan="7">
										<TableLoading />
									</td>
								</tr>
							{:else if $data?.response}
								{#each $data.response as row}
									<tr class="odd:bg-white even:bg-gray-50 p-1">
										<td class="border-b p-2.5 text-center leading-5">{row.provincia ?? ''}</td>
										<td class="border-b p-2.5 text-center leading-5">{row.citta ?? ''}</td>
										<td class="border-b p-2.5 text-center leading-5">{row.cap ?? ''}</td>
										<td class="border-b p-2.5 text-center leading-5"
											>{row.indirizzo ?? ''}
											{#if row.provincia && row.citta && row.cap && row.indirizzoOK}
												<span
													title="{$_('page.employee.list.valid_address')}"
													class="material-icons-outlined"
													style="color: green; font-size: 20px;">fmd_good</span
												>
											{:else}
												<span
													title="{$_('page.employee.list.not_valid_address')}"
													class="material-icons-outlined"
													style="color: red; font-size: 20px;">wrong_location</span
												>{/if}</td
										>
										<td class="border-b p-2.5 text-center leading-5">{row.sede?.denominazione ?? ''}</td>
										<td class="border-b p-2.5 text-center leading-5"
											>{#if row.indirizzoCancel} <Checkbox disabled /> {:else} <Checkbox disabled checked /> {/if}</td
										>
									</tr>
								{/each}
							{/if}
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
	<div class="right-0">
		{#if $data?.response}
			<Pagination bind:current="{filters.pagina}" bind:num_pages="{$data.totalPages}" bind:per_page="{filters.elementiPerPagina}" />
		{/if}
	</div>
</Card>